
function HintHelper (word, line, column, callback) {
    this.active = true
    this.word = word
    this.line = line
    this.column = column
    this.callback = callback
    this.scanner = false
    this.after = {
        line: -1,
        column: -1
    }
    this.hints = []
    this.scanner = false
}

HintHelper.prototype = {
    isActive () {
        return this.active
    },
    disable () {
        this.active = false
    },
    setScanner (scanner) {
        this.scanner = scanner
    },
    afterToken (token) {
        this.after.line = token.line
        this.after.column = token.column
    },
    afterLine (token) {
        this.after.line = token.line + 1
        this.after.column = -1
    },
    checkTokensForHints (tokens, addAll, appendList) {
        if (!this.active) {
            return
        }
        if (this.line < this.after.line) {
            return
        } else if (this.column < this.after.column) {
            return
        }
        if (this.scanner.next().line !== undefined) {
            if (this.scanner.next().line < this.line) {
                return
            } else if (this.scanner.next().column < this.column) {
                return
            }
        }
        for (let token of tokens) {
            for (let keyword of token.keywords) {
                if (keyword.toLowerCase().startsWith(this.word.toLowerCase())) {
                    if (appendList !== undefined) {
                        for (let apToken of appendList) {
                            for (let apKeyword of apToken.keywords) {
                                this.hints.push({
                                    displayText: keyword + ' ' + apKeyword,
                                    text: keyword + ' ' + apKeyword + addAll
                                })
                            }
                        }
                    } else {
                        this.hints.push({
                            displayText: keyword,
                            text: keyword + (addAll !== undefined ? addAll : '')
                        })
                    }
                }
            }
        }
        if (this.hints.length > 0) {
            this.callback(this.hints)
        }
    }
}

export default HintHelper



// WEBPACK FOOTER //
// ./src/Core/Parser/HintHelper.js